import { Injectable } from '@angular/core';
import { BodyStyle } from '@wb/core/interfaces/body-styles';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';

export interface BodyStylesResponse {
  bodyStyles: {
    code: string;
    success: boolean;
    count: number;
    bodyStyles: [BodyStyle];
  };
}

export interface BodyStyleFilter {
  vehicle_uid?: String;
  uid?: String;
}

export interface BodyStyleQueryVariables {
  limit?: number;
  offset?: number;
  where?: BodyStyleFilter;
}

@Injectable({
  providedIn: 'root',
})
export class BodyStylesGQL extends Query<BodyStylesResponse, BodyStyleQueryVariables> {
  document = gql(`
    query bodyStyles($where: ModelBodyStyleFilterInput, $limit: Int, $offset: Int, $sortDirection: ModelSortDirection) {
      bodyStyles(where: $where, limit: $limit, offset: $offset, sortDirection: $sortDirection) {
        code
        success
        count
        bodyStyles {
          uid
          body
          webbuy
          atc
          collateral_type
        }
      }
    }
  `);
}

export interface BodyStyleResponse {
  bodyStyle: {
    code: string;
    success: boolean;
    bodyStyle: BodyStyle;
  };
}

@Injectable({
  providedIn: 'root',
})
export class BodyStyleGQL extends Query<BodyStyleResponse> {
  document = gql(`
    query bodyStyle($uid: String!) {
      bodyStyle (uid: $uid) {
        code
        success
        bodyStyle {
          uid
          body
          webbuy
          atc
          collateral_type
        }
      }
    }
  `);
}
